export const activityNature = [
  { _id: 0, title: "Outdoor" },
  { _id: 1, title: "Indoor" },
  { _id: 2, title: "Hybrid" },
];

export const activityStatus = [
  { _id: 0, title: "Active" },
  { _id: 1, title: "Completed" },
  { _id: 2, title: "Cancelled" },
  { _id: 3, title: "Pending" },
];
